/* eslint-disable @typescript-eslint/ban-types */
import QueryTags from '../types/QueryTags'
import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions'
import { BaseQueryFn, FetchArgs, FetchBaseQueryError, FetchBaseQueryMeta } from '@reduxjs/toolkit/query/react'


const authBasePath = '/membership/members'

const nonMembershipEndpoints = (builder: EndpointBuilder<
  BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError, {}, FetchBaseQueryMeta>, QueryTags, 'data'>) =>
({
  fetchNonMembers: builder.query<any, string>({
    query: () => ({
      url: `${authBasePath}?page=0&size=100`,
      method: 'get',
    }),
    providesTags: ['members'],
  }),

  createNonMember: builder.mutation<any, any>({
    query: (body) => ({
      url: `${authBasePath}/register`,
      method: 'post',
      body,
    }),
    invalidatesTags: ['members'],
  }),

  updateNonMember: builder.mutation<any, any>({
    query: ({ id, body }) => ({
      url: `${authBasePath}/${id}`,
      method: 'put',
      body,
    }),
    invalidatesTags: ['members'],
  }),

  deleteNonMember: builder.mutation<any, any>({
    query: (id) => ({
      url: `${authBasePath}/${id}`,
      method: 'delete',
    }),
    invalidatesTags: ['members'],
  }),

})

export default nonMembershipEndpoints



